const GA_ID = process.env.GOOGLE_ANALYTICS_ID || '';

export default {
    performanceTrackers: {},
    load() {
        window.ga = window.ga || function() {
            (window.ga.q = window.ga.q || []).push(arguments);
        };

        window.ga.l = +new Date();
        window.ga('create', GA_ID, 'auto');
        window.ga('set', 'anonymizeIp', true);

        const m = document.getElementsByTagName('script')[0];
        let script = document.createElement('script');
        script.async = 1;
        script.src = 'https://www.google-analytics.com/analytics.js';
        m.parentNode.insertBefore(script, m);
    },

    init() {
        if(!GA_ID) {
            return;
        }

        this.load();
    },

    trackPageView() {
        if(!GA_ID || !window.ga) {
            return;
        }

        window.ga('send', {
            hitType: 'pageView',
            page: location.pathname
        });
    },

    trackEvent(category, action, label = null, val = null) {
        if(!GA_ID || !window.ga) {
            return;
        }

        window.ga('send', {
            hitType: 'event',
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            eventValue: val,
        });
    },

    trackInitialPerformance() {
        if(!GA_ID || !window.ga || !window.performance) {
            return;
        }
        // Gets the number of milliseconds since page load
        // (and rounds the result since the value must be an integer).

        let timeSincePageLoad;
        let p = window.performance;
        if('now' in p) {
            timeSincePageLoad = Math.round(p.now());
        } else {
            let nowOffset = Date.now();
            if(p.timing && p.timing.navigationStart) {
                nowOffset = p.timing.navigationStart;
            }
            timeSincePageLoad = Math.round(new Date().getTime() - nowOffset);
        }

        window.ga('send', {
            hitType: 'timing',
            timingCategory: 'JS Dependencies',
            timingVar: 'load',
            timingValue: timeSincePageLoad
        });
    },

    trackPerformanceStart(id) {
        this.performanceTrackers[id] = new Date().getTime();
    },

    canceltrackPerformance(id) {
        delete this.performanceTrackers[id];
    },

    trackPerformanceEnd(id, varname = null, label = null, category = 'API Requests') {
        if(!GA_ID || !window.ga || !this.performanceTrackers[id]) {
            return;
        }
        const end = new Date().getTime();
        const time = end - this.performanceTrackers[id];

        window.ga('send', {
            hitType: 'timing',
            timingCategory: category,
            timingVar: varname || 'get',
            timingLabel: label || id,
            timingValue: time,
        });

        this.canceltrackPerformance(id);
    },
};



// WEBPACK FOOTER //
// ./src/utils/Tracking.js